module.exports = __webpack_public_path__ + "static/media/united-kingdom.67184f51.svg";